import { call, put, select } from 'redux-saga/effects';
import {
  initCardPayment as initCardPaymentAda,
} from '@bitComponents/adabyron/payment';
import { WEB_SERVICES } from './webServices';

const contextStore = state => state.context.data;

export function* initCardPayment(params) {
  const {
    reduxUpdate, normalizeHttpErrors, cqId,
  } = params;
  const data = {
    cqId,
  };
  try {
    const { successUpdate } = reduxUpdate;
    const context = yield select(contextStore);
    const response = yield call(initCardPaymentAda, data, context);
    yield put(successUpdate(response));
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.INIT_CARD_PAYMENT, error);
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }
  }
}
